/**
 * These configuration properties are also set in application.properties (brie-ri) and UploadConfigurationProperties.java
 */
export const allowedMimeTypes = [
	'text/plain',
	'text/csv',
	'application/rtf',

	// docx, xlsx, pptx
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation',

	// odt, ods, odp
	'application/vnd.oasis.opendocument.text',
	'application/vnd.oasis.opendocument.spreadsheet',
	'application/vnd.oasis.opendocument.presentation',

	// doc, xls, ppt
	'application/msword',
	'application/vnd.ms-excel',
	'application/vnd.ms-powerpoint',

	'application/vnd.apple.unknown.13',
	'application/vnd.apple.keynote.13',
	'application/vnd.apple.keynote',
	'application/vnd.apple.numbers',
	'application/vnd.apple.pages',
	'image/jpeg',
	'image/png',
	'image/gif',
	'image/bmp',
	'image/tiff',

	'application/pdf'
];

export const maxFiles = 5;

/**
 * Maximum file size in MB
 * Should be the same as in application.properties (brie-ri)
 */
export const maxFileSizeInMb = 10;
